import { render, staticRenderFns } from "./FonteSincronizadorC.vue?vue&type=template&id=dd55fa54&scoped=true"
import script from "./FonteSincronizadorC.vue?vue&type=script&lang=js"
export * from "./FonteSincronizadorC.vue?vue&type=script&lang=js"
import style0 from "./FonteSincronizadorC.vue?vue&type=style&index=0&id=dd55fa54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd55fa54",
  null
  
)

export default component.exports